export const SourcingAllyPrices = {
    dev: {
        professional: {
            yearly: "price_1R2HUyHzQHNRsFTsYY0ihPWc",
            monthly: "price_1R2HTpHzQHNRsFTsq5M8clpc"
        }
    },
    prod: {
        professional: {
            yearly: "price_1R2HUyHzQHNRsFTsekH6vTfi",
            monthly: "price_1R2HTpHzQHNRsFTsP2I42GbD"
        }
    }
}